import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, index }) => (
  <div className="mb-5 flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.25em] text-[var(--red)]">
    {index && <span className="text-zinc-400">{index}</span>}
    <span className="h-px w-8 bg-[var(--red)]" />
    {children}
  </div>
);
